export var RateSource;
(function (RateSource) {
    RateSource["onChain"] = "onChain";
    RateSource["fusion"] = "fusion";
    RateSource["fusionPlus"] = "fusionPlus";
})(RateSource || (RateSource = {}));
//# sourceMappingURL=rate.js.map